module.exports = __webpack_public_path__ + "img/Terraform-2.da56009e.png";